import { PageId } from 'constants/pages'

export const enum PageIdStylioSnrs2 {
  AGE_SNRS2 = PageId.AGE_SNRS2,
  URGE_SNRS2 = PageId.URGE_SNRS2,
  HAIR_COLOR_SNRS2 = PageId.HAIR_COLOR_SNRS2,
  EYES_COLOR_SNRS2 = PageId.EYES_COLOR_SNRS2,
  JEWELRY_SNRS2 = PageId.JEWELRY_SNRS2,
  BODY_SHAPE_SNRS2 = PageId.BODY_SHAPE_SNRS2,
  STYLIO_TO_HELP_SNRS2 = PageId.STYLIO_TO_HELP_SNRS2,
  TALL_SNRS2 = PageId.TALL_SNRS2,
  WEIGHT_SNRS2 = PageId.WEIGHT_SNRS2,
  URGE_2_SNRS2 = PageId.URGE_2_SNRS2,
  SHOPPING_SNRS2 = PageId.SHOPPING_SNRS2,
  STYLE_MOST_MATTERS_SNRS2 = PageId.STYLE_MOST_MATTERS_SNRS2,
  FAVORITE_COLORS_SNRS2 = PageId.FAVORITE_COLORS_SNRS2,
  LIKE_OR_DISLIKE_SNRS2_1 = PageId.LIKE_OR_DISLIKE_SNRS2_1,
  LIKE_OR_DISLIKE_SNRS2_2 = PageId.LIKE_OR_DISLIKE_SNRS2_2,
  LIKE_OR_DISLIKE_SNRS2_3 = PageId.LIKE_OR_DISLIKE_SNRS2_3,
  LIKE_OR_DISLIKE_SNRS2_4 = PageId.LIKE_OR_DISLIKE_SNRS2_4,
  LIKE_OR_DISLIKE_SNRS2_5 = PageId.LIKE_OR_DISLIKE_SNRS2_5,
  LIKE_OR_DISLIKE_SNRS2_6 = PageId.LIKE_OR_DISLIKE_SNRS2_6,
  LIKE_OR_DISLIKE_SNRS2_7 = PageId.LIKE_OR_DISLIKE_SNRS2_7,
  LIKE_OR_DISLIKE_SNRS2_8 = PageId.LIKE_OR_DISLIKE_SNRS2_8,
  STYLES_FEEL_LIKE_YOU_SNRS2 = PageId.STYLES_FEEL_LIKE_YOU_SNRS2,
  URGE_4_SNRS2 = PageId.URGE_4_SNRS2,
  BRAND_SNRS2 = PageId.BRAND_SNRS2,
  FIND_NEW_CLOTHES_SNRS2 = PageId.FIND_NEW_CLOTHES_SNRS2,
  NOTHING_TO_WEAR_SNRS2 = PageId.NOTHING_TO_WEAR_SNRS2,
  OLD_CLOTHES_SNRS2 = PageId.OLD_CLOTHES_SNRS2,
  COMBINE_CLOTHES_SNRS2 = PageId.COMBINE_CLOTHES_SNRS2,
  OUTFIT_LOOK_SNRS2 = PageId.OUTFIT_LOOK_SNRS2,
  OPTIMIZE_BUDGET_SNRS2 = PageId.OPTIMIZE_BUDGET_SNRS2,
  EVERYDAY_LIFESTYLE_SNRS2 = PageId.EVERYDAY_LIFESTYLE_SNRS2,
  CLIMAT_SNRS2 = PageId.CLIMAT_SNRS2,
  URGE_3_SNRS2 = PageId.URGE_3_SNRS2,
  PREPARE_FLOW_SNRS2 = PageId.PREPARE_FLOW_SNRS2,
  EMAIL_SNRS2 = PageId.EMAIL_SNRS2,
  SUBSCRIPTIONS_SNRS2 = PageId.SUBSCRIPTIONS_SNRS2,
  CANCEL_OFFER_SNRS2 = PageId.CANCEL_OFFER_SNRS2,
  SUB_UPSELL_SNRS2 = PageId.SUB_UPSELL_SNRS2,
  UPSELL_SNRS_2 = PageId.UPSELL_SNRS_2,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_SNRS2 = PageId.DOWNLOAD_SNRS2,
}
